export default __webpack_public_path__ + "static/media/spinner.9e7aae8d.svg";